var map = {
	"./images/Education_Flyer.jpg": 81,
	"./images/MainLabor.jpg": 117,
	"./images/MainMarriage.jpg": 205,
	"./images/Russell-Watkins.jpg": 118,
	"./images/bdphand.png": 206,
	"./images/bdplogo.png": 207,
	"./images/educationArticle1.jpg": 152,
	"./images/educationArticle2.jpg": 153,
	"./images/educationArticle3.jpg": 154,
	"./images/educationProject/EducationProject1.jpg": 208,
	"./images/education_video.mp4": 85,
	"./images/educationmain.jpg": 119,
	"./images/healthArticle1.jpg": 155,
	"./images/healthArticle2.jpg": 156,
	"./images/healthcard1.jpg": 157,
	"./images/home.jpg": 209,
	"./images/laborArticle1.jpg": 158,
	"./images/laborArticle2.jpg": 159,
	"./images/laborArticle3.jpg": 160,
	"./images/logoBDP.png": 114,
	"./images/mainProstitution.jpg": 120,
	"./images/marriageArticle1.jpg": 161,
	"./images/marriageArticle2.jpg": 162,
	"./images/marriageArticle3.jpg": 163,
	"./images/oldteam.jpg": 116,
	"./images/pinkMarriage.jpg": 121,
	"./images/prostitutionArticle1.jpg": 164,
	"./images/prostitutionArticle2.jpg": 165,
	"./images/prostitutionArticle3.jpg": 166,
	"./images/ramadan/1.jpg": 122,
	"./images/ramadan/2.jpg": 123,
	"./images/ramadan/3.jpg": 124,
	"./images/ramadan/4.jpg": 125,
	"./images/ramadan/5.jpg": 126,
	"./images/ramadan/6.jpg": 127,
	"./images/ramadan/7.jpg": 128,
	"./images/ramadan2019/Ramadan1.jpeg": 210,
	"./images/team/Amina.jpg": 129,
	"./images/team/Ashabul.jpg": 130,
	"./images/team/Ferdous.jpg": 131,
	"./images/team/Jaheen.JPG": 132,
	"./images/team/Karima.jpg": 133,
	"./images/team/Marjan.jpg": 134,
	"./images/team/Momo.jpg": 135,
	"./images/team/Mosammat.jpg": 136,
	"./images/team/Naiful.jpg": 137,
	"./images/team/Noshin.jpg": 138,
	"./images/team/Prema.jpg": 139,
	"./images/team/Priya.jpg": 140,
	"./images/team/Sila.jpg": 141,
	"./images/team/Simran.jpg": 142,
	"./images/team/Tahmid.jpg": 143,
	"./images/team/Tanjeela.jpg": 144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 396;